import { useEffect, useRef } from 'react';

import { useEnvironment } from 'contexts/UserEnvironmentContext';
import {
  useSearchActions,
  useSearchLocation,
} from 'modules/search/contexts/SearchContext';
import { searchGetInitialLocation } from 'modules/search/helpers/searchGetInitialLocation';

export function useUpdateSearchLocationFromLocalStorage() {
  const { environment } = useEnvironment();

  const searchLocation = useSearchLocation();
  const { updateSearchLocation } = useSearchActions();

  const triggeredRef = useRef(false);

  useEffect(() => {
    if (!environment || triggeredRef.current) return;
    triggeredRef.current = true;

    if (!searchLocation) {
      updateSearchLocation(
        searchGetInitialLocation(environment.guessedLocation),
        false,
      );
    }
  }, [environment, searchLocation, updateSearchLocation]);
}
